import { render, staticRenderFns } from "./LetterDetails.vue?vue&type=template&id=ca7537bc&"
import script from "./LetterDetails.vue?vue&type=script&lang=js&"
export * from "./LetterDetails.vue?vue&type=script&lang=js&"
import style0 from "./LetterDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports